import { createClient, type FunctionInvokeOptions } from '@supabase/supabase-js';

const {
  VITE_SUPABASE_PROJECT_URL: PROJECT_URL,
  VITE_SUPABASE_ANON_KEY: PROJECT_KEY,
} = import.meta.env;

const supabaseClient = createClient(PROJECT_URL, PROJECT_KEY);

let activeOrganizationId: string | undefined;

export const setApiOrganizationId = (organizationId: string | undefined) => {
  activeOrganizationId = organizationId;
};

export const baseApi = {
  auth: supabaseClient.auth,
  from: supabaseClient.from.bind(supabaseClient),
  functions: {
    invoke: <T>(functionName: string, options?: FunctionInvokeOptions) => {
      const headers: Record<string, string> = {
        ...options?.headers,
      };

      if (activeOrganizationId) {
        headers['x-organization-id'] = activeOrganizationId;
      }

      return supabaseClient.functions.invoke<T>(functionName, {
        ...options,
        headers,
      });
    },
  },
};
